"use client";
import { useState } from "react";
const Faq = ({ faqItem }) => {
  const [activeIndex, setActiveIndex] = useState(null);

  const handleClick = (index) => {
    setActiveIndex(activeIndex === index ? null : index);
  };
  return (
    <>
      {faqItem?.map((faq, index) => (
        <div
          className="accordionItem"
          key={index}
          onClick={() => handleClick(index)}
        >
          <div className="accordionHeader">
            {faq.question}
            <span className={`${activeIndex === index ? "active" : ""}`}></span>
          </div>
          <div
            className={`accordionContent ${
              activeIndex === index ? "open" : ""
            }`}
          >
            <div
              dangerouslySetInnerHTML={{
                __html: faq.answer,
              }}
            />
          </div>
        </div>
      ))}
    </>
  );
};

export default Faq;
